import React from 'react';
import moment from 'moment';
import { RadioSwitch } from '../../../components/RadioSwitch/RadioSwitch';
import { DonutChart } from '../../../components/DonutChart/DonutChart';
import { IconButton } from '../../../components/IconButton/IconButton';
import { ONE_DAY, ONE_MONTH, ONE_WEEK } from '../../../../const/periodRanges';
import { confirmAlert } from '../../../../services/mini/alanConfirmAlert';
import ConfirmPopup from '../../../components/ConfirmPopup/ConfirmPopup';
import InlineEditor from '../../../components/InlineEditor/InlineEditor';
import Menu from '../../../components/Menu/Menu';
import capitalize from '../../../../services/mini/capitalize';
import { AnalyticsFilterWithCombobox } from '../AnalyticsFilter/AnalyticsFilterWithCombobox';
import { PredefinedDateRangeCombobox } from '../AnalyticsFilter/PredefinedDateRangeCombobox';
import { validateAnalyticsReportName } from '../../../../services/validations/validateAnalyticsReportName';
import * as actions from '../../../../redux/projectAnalytics/actions.projectAnalytics';
import { connect } from 'react-redux';
import asyncDispatch from '../../../../services/mini/asyncDispatch';
import { AnalyticsChartPeriods } from '../../../../services/mini/analytics/analyticsChartPeriods';
import { generateDatesByCustomRange } from '../../../../services/mini/analytics/generateDatesByCustomRange';
import { CustomDateRange } from '../../../../services/mini/analytics/customDateRange';
import { CustomDatePicker } from '../../../components/DatePicker/CustomDatePicker';
import _ from 'lodash';

const predefinedFilters = {
    browser: {
        chrome: {
            label: 'Chrome',
            key: 'chrome',
        },
        safari: {
            label: 'Safari',
            key: 'safari',
        },
    },
    platform: {
        web: {
            label: 'Web',
            key: 'web',
        },
        ios: {
            label: 'iOS',
            key: 'ios',
        },
        android: {
            label: 'Android',
            key: 'android',
        },
    }
};

export const dateFilterPeriods = [
    {
        label: 'Daily',
        key: ONE_DAY,
    },
    {
        label: 'Weekly',
        key: ONE_WEEK,
    },
    {
        label: 'Monthly',
        key: ONE_MONTH,
    },
];

class AnalyticsFilter extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            selectedCustomDateRange: CustomDateRange.Custom
        };
    }

    renameReport = (newReportName,) => {
        const { renameAnalyticsReport, project, report } = this.props;

        renameAnalyticsReport({
            project,
            reportName: report.name,
            newReportName,
        });
    }

    deleteReport = () => {
        const { deleteAnalyticsReport, project, report } = this.props;

        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <ConfirmPopup
                        onClose={onClose}
                        okBtnLabel="Delete"
                        okBtnCb={() => {
                            onClose();

                            deleteAnalyticsReport({
                                project,
                                reportName: report.name,
                            });
                        }}
                        title="Delete"
                        message={<div>Are you sure you want to delete <b>{`${report.name}`}</b>?</div>}
                    />
                );
            }
        });
    };

    validateReportName = (reportName) => {
        const { reports } = this.props;
        let error, info = null;
        let res = {};

        error = validateAnalyticsReportName(reportName, reports.map(report => report.name));

        if (reportName.length > 50) {
            info = `Max statistics name length: 50 characters`;
        }

        if (error) {
            res.error = error;
        }

        if (info) {
            res.info = info;
        }

        return res;
    }

    onPeriodChange = (period) => {
        const { changeAnalyticsPeriodReportFilter, projectId, report, environment } = this.props;
        let dates = {};
        let nextPeriod = period.key;

        if (nextPeriod === AnalyticsChartPeriods.Daily) {
            dates.startTs = +moment(report.startTs);
            if (+report.endTs <= Date.now()) {
                dates.endTs = +moment(report.endTs).endOf('day');
            } else {
                dates.endTs = +moment().endOf('day');
            }
        } else if (nextPeriod === AnalyticsChartPeriods.Weekly) {
            dates.startTs = +moment(report.startTs).startOf('isoWeek');
            dates.endTs = +moment(report.endTs).endOf('isoWeek');
        } else if (nextPeriod === AnalyticsChartPeriods.Monthly) {
            const nextEndOfMonth = moment(report.endTs).endOf('month');
            const endOfCurMonth = moment().endOf('month');
            dates.startTs = +moment(report.startTs).startOf('month');
            if (+nextEndOfMonth > +endOfCurMonth) {
                dates.endTs = +endOfCurMonth;
            } else {
                dates.endTs = +nextEndOfMonth;
            }
        }

        changeAnalyticsPeriodReportFilter({
            projectId,
            environment,
            reportName: report.name,
            period: period.key,
            ...dates
        });
    };

    onCustomDateRangeChange = (dateRangeKey) => {
        const { startTs, endTs } = generateDatesByCustomRange(dateRangeKey);
        console.info('dateRangeKey', dateRangeKey, startTs, endTs);
        this.setState({ selectedCustomDateRange: dateRangeKey });
        if (dateRangeKey !== CustomDateRange.Custom) {
            this.changeAnalyticsDateRangeFilter(startTs, endTs);
        }
    }

    onCalendarClose = () => {
        const { period, report } = this.props;
        if (period === AnalyticsChartPeriods.Daily && !report.endTs) {
            this.changeAnalyticsDateRangeFilter(report.startTs, moment(report.startTs).endOf('day'));
        }
    }

    onDateChange = (date) => {
        let [startDate, endDate] = date;

        this.setState({ selectedCustomDateRange: CustomDateRange.Custom });
        this.changeAnalyticsDateRangeFilter(startDate, endDate);
    }

    changeAnalyticsDateRangeFilter = (startTs, endTs) => {
        const {
            getDataByReport,
            changeAnalyticsDateRangeReportFilter,
            projectId,
            report,
            environment
        } = this.props;

        changeAnalyticsDateRangeReportFilter({
            projectId,
            reportName: report.name,
            startTs: startTs ? +startTs : null,
            endTs: endTs ? +endTs : null,
            environment
        });
    }

    enterEditMode = () => {
        this.setState({ editStatNameMode: true });
    }

    cancelEditMode = () => {
        this.setState({ editStatNameMode: false });
    }

    addReportFilter = ({ filters, filterIndex }) => {
        const { addAnalyticsReportFilter, projectId, report } = this.props;
        addAnalyticsReportFilter({
            projectId,
            reportName: report.name,
            filters,
            filterIndex,
        });
    }

    deleteReportFilter = (filterIndex) => {
        const { deleteAnalyticsReportFilter, projectId, report, } = this.props;
        deleteAnalyticsReportFilter({
            projectId,
            reportName: report.name,
            filterIndex: filterIndex,
        });
    }

    addBrowserFilter = () => {
        this.addReportFilter({
            filters: [
                {
                    type: 'tag',
                    value: {
                        name: 'browser',
                        tag: predefinedFilters.browser.chrome.key
                    }
                }
            ]
        });
    }

    addPlatformFilter = () => {
        this.addReportFilter({
            filters: [
                {
                    type: 'tag',
                    value: {
                        name: 'platform',
                        tag: predefinedFilters.platform.web.key
                    }
                }
            ]
        });
    }

    changeFilter = (index, filterKey, filterValue) => {
        this.addReportFilter({
            filters: [
                {
                    type: 'tag',
                    value: {
                        name: filterKey,
                        tag: filterValue
                    }
                }
            ],
            filterIndex: index
        });
    }

    render() {
        const { selectedCustomDateRange } = this.state;
        const { filtersExpanded, report, canBeDeleted, canBeRenamed, project } = this.props;
        const { filters, period, startTs: startDate, endTs: endDate, name } = report;

        const noFilters = filters.length === 0;

        return <div className="analytics-filter">
            <div className="analytics-filter__row">
                <div className="analytics-filter__header">
                    <div className="analytics-filter__header-info">
                        {/* <DonutChart value={100} color={'#006DEA'} label={'Users'} /> */}
                        <div className="analytics-filter__title">
                            <InlineEditor
                                value={name}
                                readOnly={!canBeRenamed}
                                autoFocus={true}
                                validate={this.validateReportName}
                                maxLength={50}
                                onEnterEditMode={this.enterEditMode}
                                onLeaveEditMode={this.cancelEditMode}
                                confirmAction={(newReportName) => {
                                    this.renameReport(newReportName);
                                }} />
                        </div>
                    </div>
                    {canBeDeleted && <i className="icon icon-alan-test-delete analytics-filter__delete-stats-btn" onClick={this.deleteReport} />}
                </div>
            </div>
            <div className="analytics-filter__row">
                <RadioSwitch
                    className={_.isEmpty(report.data) ? 'disabled' : ''}
                    radios={dateFilterPeriods}
                    onChange={this.onPeriodChange}
                    active={period} />
                <CustomDatePicker
                    startFromDate={new Date(+project.createTs)}
                    showMonthYearPicker={period === AnalyticsChartPeriods.Monthly}
                    period={period}
                    startDate={startDate}
                    endDate={endDate}
                    onChange={this.onDateChange}
                    onCalendarClose={this.onCalendarClose} />
                {/* <PredefinedDateRangeCombobox
                    className="analytics-filter__custom-date-range-cb"
                    value={selectedCustomDateRange}
                    onChange={this.onCustomDateRangeChange} /> */}
                {/* <div>
                    <IconButton label={''} icon={'filter'} onClick={this.props.toggleFilters} >
                        {!noFilters && <div className={`analytics-filter__filter-count-badge`}>
                            {filters.length}
                        </div>}
                    </IconButton>
                </div> */}

            </div>
            {
                filtersExpanded && <div className={`analytics-filter__filters ${noFilters && 'no-filters'}`}>
                    <Menu
                        className="analytics-filter__add-filter-btn"
                        fixed={true}
                        width={162}
                        button={<IconButton label={''} icon={'add-circle'} onClick={this.addFilter} />}>
                        <div onClick={this.addBrowserFilter}>
                            <i className="icon icon-alan-stat-browser" />Browser
                        </div>
                        <div onClick={this.addPlatformFilter}>
                            <i className="icon icon-alan-stat-platform" />Platform
                        </div>
                    </Menu>

                    {filters.map((filter, index) => {
                        const filterKey = filter.value.name;
                        return <AnalyticsFilterWithCombobox
                            key={`filter-browser-${filter.value.tag}-${index}`}
                            name={capitalize(filter.value.name)}
                            value={filter.value.tag}
                            values={Object.values(predefinedFilters[filter.value.name])}
                            onChange={({ key: filterValue }) => {
                                this.changeFilter(index, filterKey, filterValue);
                            }}
                            onDelete={() => {
                                this.deleteReportFilter(index);
                            }}
                        />;
                    })}
                </div>
            }
        </div >;
    }
}


function mapStateToProps({ projectsInfo }, ownProps) {

    return {
    };
}


function mapDispatchToProps(dispatch) {
    return {
        getDataByReport: (param) => asyncDispatch(actions.getDataByReport, dispatch, param),
        renameAnalyticsReport: (param) => asyncDispatch(actions.renameAnalyticsReport, dispatch, param),
        deleteAnalyticsReport: (param) => asyncDispatch(actions.deleteAnalyticsReport, dispatch, param),
        addAnalyticsReportFilter: (param) => asyncDispatch(actions.addAnalyticsReportFilter, dispatch, param),
        deleteAnalyticsReportFilter: (param) => asyncDispatch(actions.deleteAnalyticsReportFilter, dispatch, param),
        changeAnalyticsPeriodReportFilter: (param) => asyncDispatch(actions.changeAnalyticsPeriodReportFilter, dispatch, param),
        changeAnalyticsDateRangeReportFilter: (param) => asyncDispatch(actions.changeAnalyticsDateRangeReportFilter, dispatch, param),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(AnalyticsFilter);